import { render, staticRenderFns } from "./IssueTable.vue?vue&type=template&id=5758b021&scoped=true"
import script from "./IssueTable.vue?vue&type=script&lang=js"
export * from "./IssueTable.vue?vue&type=script&lang=js"
import style1 from "./IssueTable.vue?vue&type=style&index=1&id=5758b021&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5758b021",
  null
  
)

export default component.exports